import is from '@sindresorhus/is';
import type { QueryClient, QueryKey } from '@tanstack/react-query';

import type { EntityIdentifier } from '../../data-contract/chat';
import { positionAlignmentKeys } from './query-keys';

const alignmentIdOf = (entity: EntityIdentifier): string | null => {
    if (entity.type === 'alignment') return is.nonEmptyString(entity.id) ? entity.id : null;
    return null;
};

const alignmentQueryKeys = (alignmentId: string): readonly QueryKey[] => [
    positionAlignmentKeys.threads(alignmentId),
    positionAlignmentKeys.tasks(alignmentId),
    positionAlignmentKeys.compares(alignmentId),
    positionAlignmentKeys.automations(alignmentId),
];

export const refreshAlignmentCaches = (queryClient: QueryClient, entities: readonly EntityIdentifier[]): void => {
    const alignmentIds = new Set(entities.map(alignmentIdOf).filter(is.string));
    if (alignmentIds.size === 0) return;
    for (const alignmentId of alignmentIds) {
        void queryClient.invalidateQueries({ queryKey: positionAlignmentKeys.alignmentViews(alignmentId) });
        for (const queryKey of alignmentQueryKeys(alignmentId)) void queryClient.invalidateQueries({ queryKey });
    }
    void queryClient.invalidateQueries({ queryKey: positionAlignmentKeys.me() });
    void queryClient.invalidateQueries({ queryKey: positionAlignmentKeys.team() });
};
